import React, { createContext, useState } from "react";
import { formatDate } from "../../../../utils/formatDate";
import { Estados } from "./../../../../repositories/qerpapi/erp/prouser/static/Estados";
import { Municipios } from "./../../../../repositories/qerpapi/erp/prouser/static/Municipios";
import { Paises } from "./../../../../repositories/qerpapi/erp/prouser/static/Paises";

const FornecedorContext = createContext();

const FornecedorContextProvider = ({ children }) => {
  //Contato
  const [contacts, setContacts] = useState([]);
  // Estabelecimentos Rurais
  const [ruralEstablishment, setRuralEstablishment] = useState([]);

  //Geral
  const [disabledInputCnpj, setDisabledInputCnpj] = useState(false);
  const [geralCustomerId, setGeralCustomerId] = useState(null);
  const [geralCpfcnpj, setGeralCpfCnpj] = useState("");
  const [geralRazao, setGeralRazao] = useState("");
  const [geralFantasia, setGeralFantasia] = useState("");
  const [geralCep, setGeralCEP] = useState("");
  const [geralEndereco, setGeralEndereco] = useState("");
  const [geralNumero, setGeralNumero] = useState("");
  const [geralComplemento, setGeralComplemento] = useState("");
  const [geralBairro, setGeralBairro] = useState("");
  const [geralEstado, setGeralEstado] = useState(null);
  const [geralMunicipio, setGeralMunicipio] = useState(null);
  const [geralPais, setGeralPais] = useState({
    codigo: "1058",
    descricao: "BRASIL",
    siscomex: "105",
  });
  const [geralDdd, setGeralDdd] = useState("");
  const [geralTel, setGeralTel] = useState("");
  const [geralEmail, setGeralEmail] = useState("");
  const [geralIe, setGeralIe] = useState("");
  const [geralSm, setGeralSm] = useState(null);
  const [geralCf, setGeralCf] = useState(null);
  const [geralIm, setGeralIm] = useState("");
  const [geralCelular, setGeralCelular] = useState("");
  const [geralWhatsappAtivo, setGeralWhatsappAtivo] = useState(false);
  const [geralLoading, setGeralLoading] = useState(false);
  const [geralTipoInscricao, setGeralTipoInscricao] = useState({
    descricao: "CNPJ",
  });
  const [geralErrors, setGeralErrors] = useState({});
  const [geralAtivo, setGeralAtivo] = useState(true);
  const [ruralProducer, setRuralProducer] = useState(false);
  const [validCpfCnpj, setValidCpfCnpj] = useState(false);

  //Integracao
  const [providerType, setProviderType] = useState({
    descricao: "Nenhum",
    id: 1,
  });
  const [integrationConectionCod, setIntegrationConectionCod] = useState("");
  const [integrationDueDate, setIntegrationDueDate] = useState(
    formatDate({ date: new Date(), separator: "-", format: "yyyy-mm-dd" })
  );
  const [integrationCpfcnpj, setIntegrationCpfCnpj] = useState("");
  const [integrationDescription, setIntegrationDescription] = useState("");
  const [IeIndication, setIeIndication] = useState(null);
  const [IeIndicationList, setIeIndicationList] = useState([
    {
      value: 1,
      description: "Contribuinte de ICMS",
    },
    {
      value: 2,
      description:
        "Contribuinte isento de Inscrição no cadastro de Contribuinte de ICMS",
    },
    {
      value: 9,
      description: "Não Contribuinte",
    },
  ]);

  //Outros
  const [bank, setBank] = useState([]);
  const [previsao, setPrevisao] = useState("");
  const [classificacao, setClassificacao] = useState(null);
  const [grupoEconomico, setGrupoEconomico] = useState("");
  const [observacao, setObservacao] = useState("");

  //Tela
  const [loading, setLoading] = useState(false);
  const [initialDate, setInitialDate] = useState(new Date());
  const [finalDate, setFinalDate] = useState(new Date());
  const [optionsStatus, setOptionsStatus] = useState(null);
  const [cpfcnpj, setcpfcnpj] = useState(null);
  const [remetente, setRemetente] = useState(null);
  const [nroNfe, setNronfe] = useState(null);
  const [dataRows, setDataRows] = useState([]);
  const [selectedItem, setSelectedItem] = useState([]);

  const [expanded, setExpanded] = useState({ general: true });
  const [listBank, setListBank] = useState([]);
  const [listUf, setListUf] = useState([...Estados]);
  const [listCounty, setListCounty] = useState([...Municipios]);
  const [listNation, setListNation] = useState([...Paises]);
  const [listClassifiction, setListClassifiction] = useState([]);
  const [loadingInputs, setLoadingInputs] = useState({});
  const [optionsFilterProvider, setOptionsFilterProvider] = useState([
    {
      descricao: "Nenhum",
      id: 1,
    },
  ]);

  return (
    <FornecedorContext.Provider
      value={{
        //Contato
        contacts,
        setContacts,

        //Estabelecimentos Rurais
        ruralEstablishment,
        setRuralEstablishment,

        //Geral
        geralCustomerId,
        setGeralCustomerId,
        geralCpfcnpj,
        setGeralCpfCnpj,
        geralRazao,
        setGeralRazao,
        geralFantasia,
        setGeralFantasia,
        geralCep,
        setGeralCEP,
        geralEndereco,
        setGeralEndereco,
        geralNumero,
        setGeralNumero,
        geralComplemento,
        setGeralComplemento,
        geralBairro,
        setGeralBairro,
        geralEstado,
        setGeralEstado,
        geralMunicipio,
        setGeralMunicipio,
        geralPais,
        setGeralPais,
        geralDdd,
        setGeralDdd,
        geralTel,
        setGeralTel,
        geralEmail,
        setGeralEmail,
        geralIe,
        setGeralIe,
        geralSm,
        setGeralSm,
        geralCf,
        setGeralCf,
        geralIm,
        setGeralIm,
        geralLoading,
        setGeralLoading,
        geralTipoInscricao,
        setGeralTipoInscricao,
        geralErrors,
        setGeralErrors,
        geralAtivo,
        setGeralAtivo,
        geralCelular,
        setGeralCelular,
        geralWhatsappAtivo,
        setGeralWhatsappAtivo,
        ruralProducer,
        setRuralProducer,
        validCpfCnpj,
        setValidCpfCnpj,

        //Integracao
        providerType,
        setProviderType,
        integrationConectionCod,
        setIntegrationConectionCod,
        integrationDueDate,
        setIntegrationDueDate,
        integrationCpfcnpj,
        setIntegrationCpfCnpj,
        integrationDescription,
        setIntegrationDescription,

        //Outros
        bank,
        setBank,
        previsao,
        setPrevisao,
        classificacao,
        setClassificacao,
        grupoEconomico,
        setGrupoEconomico,
        observacao,
        setObservacao,

        //Tela
        initialDate,
        setInitialDate,
        finalDate,
        setFinalDate,
        optionsStatus,
        setOptionsStatus,
        cpfcnpj,
        setcpfcnpj,
        remetente,
        setRemetente,
        nroNfe,
        setNronfe,
        dataRows,
        setDataRows,
        selectedItem,
        setSelectedItem,
        loading,
        setLoading,

        expanded,
        setExpanded,
        listUf,
        setListUf,
        listBank,
        setListBank,
        listCounty,
        setListCounty,
        listNation,
        setListNation,
        listClassifiction,
        setListClassifiction,
        loadingInputs,
        setLoadingInputs,
        optionsFilterProvider,
        setOptionsFilterProvider,
        IeIndication,
        setIeIndication,
        IeIndicationList,
        setIeIndicationList,
        disabledInputCnpj,
        setDisabledInputCnpj,
      }}
    >
      {children}
    </FornecedorContext.Provider>
  );
};

export { FornecedorContextProvider, FornecedorContext };
